import React, { useEffect, useState } from 'react'
import useLocalization from 'hooks/useLocalization'
import { superAxiosRequest } from 'axiosApi'
import { sortASC } from 'helpers'
import { dateFormat } from 'helpers/date'
import PropTypes from 'prop-types'
import FormDateSelector from 'components/UI/AsideModal/Form/FormDateSelector'
import asideModalStore from 'Stores/asideModalStore'
import st from './RatingModal.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import { toJS } from 'mobx'
import Stores from 'Stores'
import { ReactComponent as IconStar } from 'components/ContentBox/img/star_gray.svg'
import { ReactComponent as IconStarFill } from 'components/ContentBox/img/star_yellow.svg'
import TextareaMarkup from 'components/UI/TextareaMarkup/TextareaMarkup'

const RatingModal = ({ user, evaluationApiLink, ratingApiLink }) => {
  const {
    modalSettings: ms,
    modalValues,
    changeValue,
    getModalValues,
    listInKeyChangeHandler,
    check,
  } = asideModalStore

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'group_rating_select',
    dict: {
      month: 'Month',
      comment_text: 'Comment',
    },
  })

  const [hoverS, setHoverS] = useState({ e: 0, r: 0 })
  const [rate, setRate] = useState([])
  const [evaluationList, setEvaluationList] = useState([])
  const [ratingList, setRatingList] = useState([])

  const onClickHandler = (evaluation_id, rating_id) => {
    setRate(
      rate.map((obj) =>
        obj.evaluation_id === evaluation_id
          ? { evaluation_id, rating_id }
          : obj,
      ),
    )
  }

  useEffect(() => {
    superAxiosRequest({
      link: evaluationApiLink,
      method: 'get',
      params: {
        limit: 999,
        ...(ms.payload.isResponsible && {
          responsible: true,
        }),
      },
    })
      .then((res) => {
        setEvaluationList(res.data.result)
        if (!ms.is_put) {
          setRate(
            res.data.result.map((eva) => ({
              evaluation_id: eva.id,
              rating_id: null,
            })),
          )
        }
      })
      .catch(() => {})
    superAxiosRequest({
      link: ratingApiLink,
      method: 'get',
      params: {
        limit: 999,
        ...(ms.payload.isResponsible && {
          responsible: true,
        }),
      },
    })
      .then((res) => {
        setRatingList(res.data.result)
      })
      .catch(() => {})
  }, [evaluationApiLink, ratingApiLink])

  useEffect(() => {
    listInKeyChangeHandler(sortASC(rate, 'evaluation'), 'rate_list')
  }, [rate])

  useEffect(() => {
    if (!getModalValues.rate_list?.length) return
    setRate([...getModalValues.rate_list])
  }, [])

  return (
    <div className={st.container}>
      <div className={st.data}>
        <FormDateSelector
          flexBasis='50%'
          placeholder={translate?.month}
          isRequired={false}
          label={translate?.month + ':'}
          onChange={(val) =>
            changeValue(dateFormat(val, 'YYYY-mm-dd'), 'start_date')
          }
          value={modalValues.start_date || ''}
          error={check('start_date')}
        />
        <FormField flexBasis='50%'>
          <FormLabel>{user?.title}</FormLabel>
          <SelectCustom
            placeholder={user.placeholder}
            options={
              ms.payload?.students
                ? toJS(ms.payload.students).map((item) => ({
                    ...item,
                    name: Stores.transliterate(item.name),
                  }))
                : [
                    {
                      id: modalValues[user.key],
                      name: ms.payload?.student_name || '',
                    },
                  ]
            }
            sortKey='name'
            valueID={modalValues[user.key]}
            onChange={(o) => changeValue(o.id, user.key)}
            isDisabled={!ms.payload?.students}
            error={check(user.key)}
          />
        </FormField>
      </div>
      <div className={st.rating}>
        {evaluationList.map((eva) => (
          <div
            key={eva.id}
            className={`${st.row} ${check('rate_list') && rate.find((x) => x.evaluation_id === eva.id)?.rating_id === null ? st.rowError : ''}`}
          >
            <div>{eva.name}</div>
            {ratingList.map((r) => (
              <div
                key={r.id}
                onMouseEnter={() => setHoverS({ e: eva.id, r: r.value })}
                onMouseLeave={() => setHoverS({ e: 0, r: 0 })}
                onClick={() => onClickHandler(eva.id, r.id)}
              >
                {(eva.id === hoverS.e) & (r.value <= hoverS.r) ||
                (rate.find((x) => x.evaluation_id === eva.id)?.rating_id >=
                  r.id) &
                  (eva.id !== hoverS.e) ? (
                  <IconStarFill />
                ) : (
                  <IconStar />
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
      <FormField>
        <FormLabel>{translate?.comment_text}:</FormLabel>
        <TextareaMarkup
          onChange={(value) => {
            changeValue(value, 'comment')
          }}
          value={modalValues.comment || ''}
          placeholder={translate?.comment_text}
        />
      </FormField>
    </div>
  )
}

RatingModal.propTypes = {
  evaluationApiLink: PropTypes.string.isRequired,
  ratingApiLink: PropTypes.string.isRequired,
  user: PropTypes.shape({
    title: PropTypes.string,
    placeholder: PropTypes.string,
    key: PropTypes.string,
  }).isRequired,
}

export default RatingModal
